import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';

export interface LifetimeSoftwareFeature {
  id: string;
  name: string;
  description?: string;
}

export interface LifetimePowerPlugsFeature {
  title: string;
  descriptionTop?: string;
  descriptionBottom?: string;
  btnText?: string;
  img?: string;
  report?: string;
}

export interface LifetimeSoftwareFeaturesConfig {
  [ShopifyStore.US]: LifetimeSoftwareFeature[];
  [ShopifyStore.IN]: LifetimeSoftwareFeature[];
  [ShopifyStore.EU]: LifetimeSoftwareFeature[];
  [ShopifyStore.GB]: LifetimeSoftwareFeature[];
  [ShopifyStore.AE]: LifetimeSoftwareFeature[];
  [ShopifyStore.ROW]: LifetimeSoftwareFeature[];
  [ShopifyStore.AU]: LifetimeSoftwareFeature[];
  [ShopifyStore.CA]: LifetimeSoftwareFeature[];
  [ShopifyStore.SA]: LifetimeSoftwareFeature[];
  [ShopifyStore.MX]: LifetimeSoftwareFeature[];
  [ShopifyStore.ZA]: LifetimeSoftwareFeature[];
  [ShopifyStore.JP]: LifetimeSoftwareFeature[];
}

export interface LifetimePowerPlugsForModalConfig {
  [ShopifyStore.US]: LifetimePowerPlugsFeature[];
  [ShopifyStore.IN]: LifetimePowerPlugsFeature[];
  [ShopifyStore.EU]: LifetimePowerPlugsFeature[];
  [ShopifyStore.GB]: LifetimePowerPlugsFeature[];
  [ShopifyStore.AE]: LifetimePowerPlugsFeature[];
  [ShopifyStore.ROW]: LifetimePowerPlugsFeature[];
  [ShopifyStore.AU]: LifetimePowerPlugsFeature[];
  [ShopifyStore.CA]: LifetimePowerPlugsFeature[];
  [ShopifyStore.SA]: LifetimePowerPlugsFeature[];
  [ShopifyStore.MX]: LifetimePowerPlugsFeature[];
  [ShopifyStore.ZA]: LifetimePowerPlugsFeature[];
  [ShopifyStore.JP]: LifetimePowerPlugsFeature[];
}

export const LifetimePowerPlugsModalConfig: LifetimePowerPlugsForModalConfig = {
  [ShopifyStore.US]: [
    {
      title: 'Cardio Adaptability',
      descriptionTop:
        "Monitor your heart's activity every night with this PowerPlug. It analyzes your cardio stress through detailed tachograms and Lorenz plots, providing key insights into how your heart responds to activity, stress, and rest.",
      btnText: 'View sample report',
      img: 'web_v2/rare-info-modals/cardio-adaptability-modal.png',
      report: '/web_v2/downloads/cardio-report.pdf',
    },
    {
      title: 'Cycle & Ovulation Pro',
      descriptionTop:
        'Predicts your 7-day fertile window, then confirms ovulation with over 90% accuracy—so you know if it happened. Adapts to your unique cycle, reveals hidden fertility patterns through Cycle Flags™, and compiles metrics into comprehensive reports, perfect to discuss with your doctor.',
      descriptionBottom:
        'C&O Pro adapts to every cycle — regular, irregular, long, short, or affected by PCOS/PMOS or endometriosis. Using nightly temperature data, it delivers accurate predictions and confirmations tailored to you, so you can track with confidence.',
      btnText: 'View sample report',
      img: 'web_v2/rare-info-modals/cno-modal.png',
      report: '/web_v2/womens-health/documents/C&O_Pro_Sample%20Report.pdf',
    },
    {
      title: 'UltraSync for Tesla',
      descriptionTop:
        'Imports Tesla driving data into your Ultrahuman app to personalize cabin temperature, music, and lighting based on your recovery state. Supports smoother transitions between rest and drive, bridging health insights with intelligent in-car comfort.',
      img: 'web_v2/rare-info-modals/ultra-sync-modal.png',
    },
  ],
  [ShopifyStore.CA]: [
    {
      title: 'Cardio Adaptability',
      descriptionTop:
        "Monitor your heart's activity every night with this PowerPlug. It analyzes your cardio stress through detailed tachograms and Lorenz plots, providing key insights into how your heart responds to activity, stress, and rest.",
      btnText: 'View sample report',
      img: 'web_v2/rare-info-modals/cardio-adaptability-modal.png',
      report: '/web_v2/downloads/cardio-report.pdf',
    },
    {
      title: 'Cycle & Ovulation Pro',
      descriptionTop:
        'Predicts your 7-day fertile window, then confirms ovulation with over 90% accuracy—so you know if it happened. Adapts to your unique cycle, reveals hidden fertility patterns through Cycle Flags™, and compiles metrics into comprehensive reports, perfect to discuss with your doctor.',
      descriptionBottom:
        'C&O Pro adapts to every cycle — regular, irregular, long, short, or affected by PCOS/PMOS or endometriosis. Using nightly temperature data, it delivers accurate predictions and confirmations tailored to you, so you can track with confidence.',
      btnText: 'View sample report',
      img: 'web_v2/rare-info-modals/cno-modal.png',
      report: '/web_v2/womens-health/documents/C&O_Pro_Sample%20Report.pdf',
    },
    {
      title: 'UltraSync for Tesla',
      descriptionTop:
        'Imports Tesla driving data into your Ultrahuman app to personalize cabin temperature, music, and lighting based on your recovery state. Supports smoother transitions between rest and drive, bridging health insights with intelligent in-car comfort.',
      img: 'web_v2/rare-info-modals/ultra-sync-modal.png',
    },
  ],
  [ShopifyStore.EU]: [
    {
      title: 'AFib Detection',
      descriptionTop:
        'This PowerPlug discreetly monitors your heart rhythm each night, detecting early signs of AFib (Atrial Fibrillation). It provides seamless, nocturnal monitoring with daily medical-grade reports for peace of mind.',

      btnText: 'View sample report',
      img: 'web_v2/rare-info-modals/afib-modal.png',
      report: '/web_v2/downloads/afib-report-v2.pdf',
    },
    {
      title: 'Cycle & Ovulation Pro',
      descriptionTop:
        'Predicts your 7-day fertile window, then confirms ovulation with over 90% accuracy—so you know if it happened. Adapts to your unique cycle, reveals hidden fertility patterns through Cycle Flags™, and compiles metrics into comprehensive reports, perfect to discuss with your doctor.',
      descriptionBottom:
        'C&O Pro adapts to every cycle — regular, irregular, long, short, or affected by PCOS/PMOS or endometriosis. Using nightly temperature data, it delivers accurate predictions and confirmations tailored to you, so you can track with confidence.',
      btnText: 'View sample report',
      img: 'web_v2/rare-info-modals/cno-modal.png',
      report: '/web_v2/downloads/cardio-report.pdf',
    },
    {
      title: 'UltraSync for Tesla',
      descriptionTop:
        'Imports Tesla driving data into your Ultrahuman app to personalize cabin temperature, music, and lighting based on your recovery state. Supports smoother transitions between rest and drive, bridging health insights with intelligent in-car comfort.',
      img: 'web_v2/rare-info-modals/ultra-sync-modal.png',
    },
  ],
  [ShopifyStore.AU]: [
    {
      title: 'AFib Detection',
      descriptionTop:
        'This PowerPlug discreetly monitors your heart rhythm each night, detecting early signs of AFib (Atrial Fibrillation). It provides seamless, nocturnal monitoring with daily medical-grade reports for peace of mind.',

      btnText: 'View sample report',
      img: 'web_v2/rare-info-modals/afib-modal.png',
      report: '/web_v2/downloads/afib-report-v2.pdf',
    },
    {
      title: 'Cycle & Ovulation Pro',
      descriptionTop:
        'Predicts your 7-day fertile window, then confirms ovulation with over 90% accuracy—so you know if it happened. Adapts to your unique cycle, reveals hidden fertility patterns through Cycle Flags™, and compiles metrics into comprehensive reports, perfect to discuss with your doctor.',
      descriptionBottom:
        'C&O Pro adapts to every cycle — regular, irregular, long, short, or affected by PCOS/PMOS or endometriosis. Using nightly temperature data, it delivers accurate predictions and confirmations tailored to you, so you can track with confidence.',
      btnText: 'View sample report',
      img: 'web_v2/rare-info-modals/cno-modal.png',
      report: '/web_v2/downloads/cardio-report.pdf',
    },
    {
      title: 'UltraSync for Tesla',
      descriptionTop:
        'Imports Tesla driving data into your Ultrahuman app to personalize cabin temperature, music, and lighting based on your recovery state. Supports smoother transitions between rest and drive, bridging health insights with intelligent in-car comfort.',
      img: 'web_v2/rare-info-modals/ultra-sync-modal.png',
    },
  ],
  [ShopifyStore.IN]: [
    {
      title: 'Cardio Adaptability',
      descriptionTop:
        "Monitor your heart's activity every night with this PowerPlug. It analyzes your cardio stress through detailed tachograms and Lorenz plots, providing key insights into how your heart responds to activity, stress, and rest.",
      btnText: 'View sample report',
      img: 'web_v2/rare-info-modals/cardio-adaptability-modal.png',
      report: '/web_v2/downloads/cardio-report.pdf',
    },
    {
      title: 'Cycle & Ovulation Pro',
      descriptionTop:
        'Predicts your 7-day fertile window, then confirms ovulation with over 90% accuracy—so you know if it happened. Adapts to your unique cycle, reveals hidden fertility patterns through Cycle Flags™, and compiles metrics into comprehensive reports, perfect to discuss with your doctor.',
      descriptionBottom:
        'C&O Pro adapts to every cycle — regular, irregular, long, short, or affected by PCOS/PMOS or endometriosis. Using nightly temperature data, it delivers accurate predictions and confirmations tailored to you, so you can track with confidence.',
      btnText: 'View sample report',
      img: 'web_v2/rare-info-modals/cno-modal.png',
      report: '/web_v2/womens-health/documents/C&O_Pro_Sample%20Report.pdf',
    },
    {
      title: 'UltraSync for Tesla',
      descriptionTop:
        'Imports Tesla driving data into your Ultrahuman app to personalize cabin temperature, music, and lighting based on your recovery state. Supports smoother transitions between rest and drive, bridging health insights with intelligent in-car comfort.',
      img: 'web_v2/rare-info-modals/ultra-sync-modal.png',
    },
  ],
  [ShopifyStore.GB]: [
    {
      title: 'AFib Detection',
      descriptionTop:
        'This PowerPlug discreetly monitors your heart rhythm each night, detecting early signs of AFib (Atrial Fibrillation). It provides seamless, nocturnal monitoring with daily medical-grade reports for peace of mind.',

      btnText: 'View sample report',
      img: 'web_v2/rare-info-modals/afib-modal.png',
      report: '/web_v2/downloads/afib-report-v2.pdf',
    },
    {
      title: 'Cycle & Ovulation Pro',
      descriptionTop:
        'Predicts your 7-day fertile window, then confirms ovulation with over 90% accuracy—so you know if it happened. Adapts to your unique cycle, reveals hidden fertility patterns through Cycle Flags™, and compiles metrics into comprehensive reports, perfect to discuss with your doctor.',
      descriptionBottom:
        'C&O Pro adapts to every cycle — regular, irregular, long, short, or affected by PCOS/PMOS or endometriosis. Using nightly temperature data, it delivers accurate predictions and confirmations tailored to you, so you can track with confidence.',
      btnText: 'View sample report',
      img: 'web_v2/rare-info-modals/cno-modal.png',
      report: '/web_v2/womens-health/documents/C&O_Pro_Sample%20Report.pdf',
    },
    {
      title: 'UltraSync for Tesla',
      descriptionTop:
        'Imports Tesla driving data into your Ultrahuman app to personalize cabin temperature, music, and lighting based on your recovery state. Supports smoother transitions between rest and drive, bridging health insights with intelligent in-car comfort.',
      img: 'web_v2/rare-info-modals/ultra-sync-modal.png',
    },
  ],
  [ShopifyStore.AE]: [
    {
      title: 'Cardio Adaptability',
      descriptionTop:
        "Monitor your heart's activity every night with this PowerPlug. It analyzes your cardio stress through detailed tachograms and Lorenz plots, providing key insights into how your heart responds to activity, stress, and rest.",
      btnText: 'View sample report',
      img: 'web_v2/rare-info-modals/cardio-adaptability-modal.png',
      report: '/web_v2/downloads/cardio-report.pdf',
    },
    {
      title: 'Cycle & Ovulation Pro',
      descriptionTop:
        'Predicts your 7-day fertile window, then confirms ovulation with over 90% accuracy—so you know if it happened. Adapts to your unique cycle, reveals hidden fertility patterns through Cycle Flags™, and compiles metrics into comprehensive reports, perfect to discuss with your doctor.',
      descriptionBottom:
        'C&O Pro adapts to every cycle — regular, irregular, long, short, or affected by PCOS/PMOS or endometriosis. Using nightly temperature data, it delivers accurate predictions and confirmations tailored to you, so you can track with confidence.',
      btnText: 'View sample report',
      img: 'web_v2/rare-info-modals/cno-modal.png',
      report: '/web_v2/womens-health/documents/C&O_Pro_Sample%20Report.pdf',
    },
    {
      title: 'UltraSync for Tesla',
      descriptionTop:
        'Imports Tesla driving data into your Ultrahuman app to personalize cabin temperature, music, and lighting based on your recovery state. Supports smoother transitions between rest and drive, bridging health insights with intelligent in-car comfort.',
      img: 'web_v2/rare-info-modals/ultra-sync-modal.png',
    },
  ],
  [ShopifyStore.ROW]: [
    {
      title: 'Cardio Adaptability',
      descriptionTop:
        "Monitor your heart's activity every night with this PowerPlug. It analyzes your cardio stress through detailed tachograms and Lorenz plots, providing key insights into how your heart responds to activity, stress, and rest.",
      btnText: 'View sample report',
      img: 'web_v2/rare-info-modals/cardio-adaptability-modal.png',
      report: '/web_v2/downloads/cardio-report.pdf',
    },
    {
      title: 'Cycle & Ovulation Pro',
      descriptionTop:
        'Predicts your 7-day fertile window, then confirms ovulation with over 90% accuracy—so you know if it happened. Adapts to your unique cycle, reveals hidden fertility patterns through Cycle Flags™, and compiles metrics into comprehensive reports, perfect to discuss with your doctor.',
      descriptionBottom:
        'C&O Pro adapts to every cycle — regular, irregular, long, short, or affected by PCOS/PMOS or endometriosis. Using nightly temperature data, it delivers accurate predictions and confirmations tailored to you, so you can track with confidence.',
      btnText: 'View sample report',
      img: 'web_v2/rare-info-modals/cno-modal.png',
      report: '/web_v2/womens-health/documents/C&O_Pro_Sample%20Report.pdf',
    },
    {
      title: 'UltraSync for Tesla',
      descriptionTop:
        'Imports Tesla driving data into your Ultrahuman app to personalize cabin temperature, music, and lighting based on your recovery state. Supports smoother transitions between rest and drive, bridging health insights with intelligent in-car comfort.',
      img: 'web_v2/rare-info-modals/ultra-sync-modal.png',
    },
  ],
  [ShopifyStore.SA]: [
    {
      title: 'AFib Detection',
      descriptionTop:
        'This PowerPlug discreetly monitors your heart rhythm each night, detecting early signs of AFib (Atrial Fibrillation). It provides seamless, nocturnal monitoring with daily medical-grade reports for peace of mind.',

      btnText: 'View sample report',
      img: 'web_v2/rare-info-modals/afib-modal.png',
      report: '/web_v2/downloads/afib-report-v2.pdf',
    },
    {
      title: 'Cycle & Ovulation Pro',
      descriptionTop:
        'Predicts your 7-day fertile window, then confirms ovulation with over 90% accuracy—so you know if it happened. Adapts to your unique cycle, reveals hidden fertility patterns through Cycle Flags™, and compiles metrics into comprehensive reports, perfect to discuss with your doctor.',
      descriptionBottom:
        'C&O Pro adapts to every cycle — regular, irregular, long, short, or affected by PCOS/PMOS or endometriosis. Using nightly temperature data, it delivers accurate predictions and confirmations tailored to you, so you can track with confidence.',
      btnText: 'View sample report',
      img: 'web_v2/rare-info-modals/cno-modal.png',
      report: '/web_v2/downloads/cardio-report.pdf',
    },
    {
      title: 'UltraSync for Tesla',
      descriptionTop:
        'Imports Tesla driving data into your Ultrahuman app to personalize cabin temperature, music, and lighting based on your recovery state. Supports smoother transitions between rest and drive, bridging health insights with intelligent in-car comfort.',
      img: 'web_v2/rare-info-modals/ultra-sync-modal.png',
    },
  ],
  [ShopifyStore.MX]: [
    {
      title: 'AFib Detection',
      descriptionTop:
        'This PowerPlug discreetly monitors your heart rhythm each night, detecting early signs of AFib (Atrial Fibrillation). It provides seamless, nocturnal monitoring with daily medical-grade reports for peace of mind.',

      btnText: 'View sample report',
      img: 'web_v2/rare-info-modals/afib-modal.png',
      report: '/web_v2/downloads/afib-report-v2.pdf',
    },
    {
      title: 'Cycle & Ovulation Pro',
      descriptionTop:
        'Predicts your 7-day fertile window, then confirms ovulation with over 90% accuracy—so you know if it happened. Adapts to your unique cycle, reveals hidden fertility patterns through Cycle Flags™, and compiles metrics into comprehensive reports, perfect to discuss with your doctor.',
      descriptionBottom:
        'C&O Pro adapts to every cycle — regular, irregular, long, short, or affected by PCOS/PMOS or endometriosis. Using nightly temperature data, it delivers accurate predictions and confirmations tailored to you, so you can track with confidence.',
      btnText: 'View sample report',
      img: 'web_v2/rare-info-modals/cno-modal.png',
      report: '/web_v2/downloads/cardio-report.pdf',
    },
    {
      title: 'UltraSync for Tesla',
      descriptionTop:
        'Imports Tesla driving data into your Ultrahuman app to personalize cabin temperature, music, and lighting based on your recovery state. Supports smoother transitions between rest and drive, bridging health insights with intelligent in-car comfort.',
      img: 'web_v2/rare-info-modals/ultra-sync-modal.png',
    },
  ],
  [ShopifyStore.ZA]: [
    {
      title: 'AFib Detection',
      descriptionTop:
        'This PowerPlug discreetly monitors your heart rhythm each night, detecting early signs of AFib (Atrial Fibrillation). It provides seamless, nocturnal monitoring with daily medical-grade reports for peace of mind.',

      btnText: 'View sample report',
      img: 'web_v2/rare-info-modals/afib-modal.png',
      report: '/web_v2/downloads/afib-report-v2.pdf',
    },
    {
      title: 'Cycle & Ovulation Pro',
      descriptionTop:
        'Predicts your 7-day fertile window, then confirms ovulation with over 90% accuracy—so you know if it happened. Adapts to your unique cycle, reveals hidden fertility patterns through Cycle Flags™, and compiles metrics into comprehensive reports, perfect to discuss with your doctor.',
      descriptionBottom:
        'C&O Pro adapts to every cycle — regular, irregular, long, short, or affected by PCOS/PMOS or endometriosis. Using nightly temperature data, it delivers accurate predictions and confirmations tailored to you, so you can track with confidence.',
      btnText: 'View sample report',
      img: 'web_v2/rare-info-modals/cno-modal.png',
      report: '/web_v2/downloads/cardio-report.pdf',
    },
    {
      title: 'UltraSync for Tesla',
      descriptionTop:
        'Imports Tesla driving data into your Ultrahuman app to personalize cabin temperature, music, and lighting based on your recovery state. Supports smoother transitions between rest and drive, bridging health insights with intelligent in-car comfort.',
      img: 'web_v2/rare-info-modals/ultra-sync-modal.png',
    },
  ],
  [ShopifyStore.JP]: [
    {
      title: 'AFib Detection',
      descriptionTop:
        'This PowerPlug discreetly monitors your heart rhythm each night, detecting early signs of AFib (Atrial Fibrillation). It provides seamless, nocturnal monitoring with daily medical-grade reports for peace of mind.',

      btnText: 'View sample report',
      img: 'web_v2/rare-info-modals/afib-modal.png',
      report: '/web_v2/downloads/afib-report-v2.pdf',
    },
    {
      title: 'Cycle & Ovulation Pro',
      descriptionTop:
        'Predicts your 7-day fertile window, then confirms ovulation with over 90% accuracy—so you know if it happened. Adapts to your unique cycle, reveals hidden fertility patterns through Cycle Flags™, and compiles metrics into comprehensive reports, perfect to discuss with your doctor.',
      descriptionBottom:
        'C&O Pro adapts to every cycle — regular, irregular, long, short, or affected by PCOS/PMOS or endometriosis. Using nightly temperature data, it delivers accurate predictions and confirmations tailored to you, so you can track with confidence.',
      btnText: 'View sample report',
      img: 'web_v2/rare-info-modals/cno-modal.png',
      report: '/web_v2/downloads/cardio-report.pdf',
    },
    {
      title: 'UltraSync for Tesla',
      descriptionTop:
        'Imports Tesla driving data into your Ultrahuman app to personalize cabin temperature, music, and lighting based on your recovery state. Supports smoother transitions between rest and drive, bridging health insights with intelligent in-car comfort.',
      img: 'web_v2/rare-info-modals/ultra-sync-modal.png',
    },
  ],
};

/**
 * Lifetime software features configuration based on Shopify store regions
 * Features are dynamic and depend on the store region
 */
export const lifetimeSoftwareFeaturesConfig: LifetimeSoftwareFeaturesConfig = {
  [ShopifyStore.US]: [
    {
      id: 'cardio-adaptability',
      name: 'Cardio Adaptability',
      description: 'Advanced cardiovascular monitoring and adaptation',
    },
    {
      id: 'cycle-ovulation-pro',
      name: 'Cycle & Ovulation Pro (for women)',
      description: "Comprehensive women's health tracking",
    },
    {
      id: 'tesla-sync',
      name: 'UltraSync for Tesla',
      description: 'Seamless integration with Tesla vehicles',
    },
    {
      id: 'future-powerplugs',
      name: 'All future PowerPlugs',
      description: 'Access to all upcoming software features',
    },
  ],
  [ShopifyStore.CA]: [
    {
      id: 'cardio-adaptability',
      name: 'Cardio Adaptability',
      description: 'Advanced cardiovascular monitoring and adaptation',
    },
    {
      id: 'cycle-ovulation-pro',
      name: 'Cycle & Ovulation Pro (for women)',
      description: "Comprehensive women's health tracking",
    },
    {
      id: 'tesla-sync',
      name: 'UltraSync for Tesla',
      description: 'Seamless integration with Tesla vehicles',
    },
    {
      id: 'future-powerplugs',
      name: 'All future PowerPlugs',
      description: 'Access to all upcoming software features',
    },
  ],
  [ShopifyStore.IN]: [
    {
      id: 'cardio-adaptability',
      name: 'Cardio Adaptability',
      description: 'Advanced cardiovascular monitoring and adaptation',
    },
    {
      id: 'cycle-ovulation-pro',
      name: 'Cycle & Ovulation Pro (for women)',
      description: "Comprehensive women's health tracking",
    },
    {
      id: 'tesla-sync',
      name: 'UltraSync for Tesla',
      description: 'Seamless integration with Tesla vehicles',
    },
    {
      id: 'future-powerplugs',
      name: 'All future PowerPlugs',
      description: 'Access to all upcoming software features',
    },
  ],
  [ShopifyStore.EU]: [
    {
      id: 'afib-detection',
      name: 'AFib Detection',
      description: 'Advanced atrial fibrillation detection',
    },
    {
      id: 'cycle-ovulation-pro',
      name: 'Cycle & Ovulation Pro (for women)',
      description: "Comprehensive women's health tracking",
    },
    {
      id: 'tesla-sync',
      name: 'UltraSync for Tesla',
      description: 'Seamless integration with Tesla vehicles',
    },
    {
      id: 'future-powerplugs',
      name: 'All future PowerPlugs',
      description: 'Access to all upcoming software features',
    },
  ],
  [ShopifyStore.AU]: [
    {
      id: 'afib-detection',
      name: 'AFib Detection',
      description: 'Advanced atrial fibrillation detection',
    },
    {
      id: 'cycle-ovulation-pro',
      name: 'Cycle & Ovulation Pro (for women)',
      description: "Comprehensive women's health tracking",
    },
    {
      id: 'tesla-sync',
      name: 'UltraSync for Tesla',
      description: 'Seamless integration with Tesla vehicles',
    },
    {
      id: 'future-powerplugs',
      name: 'All future PowerPlugs',
      description: 'Access to all upcoming software features',
    },
  ],
  [ShopifyStore.GB]: [
    {
      id: 'afib-detection',
      name: 'AFib Detection',
      description: 'Advanced atrial fibrillation detection',
    },
    {
      id: 'cycle-ovulation-pro',
      name: 'Cycle & Ovulation Pro (for women)',
      description: "Comprehensive women's health tracking",
    },
    {
      id: 'tesla-sync',
      name: 'UltraSync for Tesla',
      description: 'Seamless integration with Tesla vehicles',
    },
    {
      id: 'future-powerplugs',
      name: 'All future PowerPlugs',
      description: 'Access to all upcoming software features',
    },
  ],
  [ShopifyStore.AE]: [
    {
      id: 'cardio-adaptability',
      name: 'Cardio Adaptability',
      description: 'Advanced cardiovascular monitoring and adaptation',
    },
    {
      id: 'cycle-ovulation-pro',
      name: 'Cycle & Ovulation Pro (for women)',
      description: "Comprehensive women's health tracking",
    },
    {
      id: 'tesla-sync',
      name: 'UltraSync for Tesla',
      description: 'Seamless integration with Tesla vehicles',
    },
    {
      id: 'future-powerplugs',
      name: 'All future PowerPlugs',
      description: 'Access to all upcoming software features',
    },
  ],
  [ShopifyStore.ROW]: [
    {
      id: 'cardio-adaptability',
      name: 'Cardio Adaptability',
      description: 'Advanced cardiovascular monitoring and adaptation',
    },
    {
      id: 'cycle-ovulation-pro',
      name: 'Cycle & Ovulation Pro (for women)',
      description: "Comprehensive women's health tracking",
    },
    {
      id: 'tesla-sync',
      name: 'UltraSync for Tesla',
      description: 'Seamless integration with Tesla vehicles',
    },
    {
      id: 'future-powerplugs',
      name: 'All future PowerPlugs',
      description: 'Access to all upcoming software features',
    },
  ],
  [ShopifyStore.SA]: [
    {
      id: 'afib-detection',
      name: 'AFib Detection',
      description: 'Advanced atrial fibrillation detection',
    },
    {
      id: 'cycle-ovulation-pro',
      name: 'Cycle & Ovulation Pro (for women)',
      description: "Comprehensive women's health tracking",
    },
    {
      id: 'tesla-sync',
      name: 'UltraSync for Tesla',
      description: 'Seamless integration with Tesla vehicles',
    },
    {
      id: 'future-powerplugs',
      name: 'All future PowerPlugs',
      description: 'Access to all upcoming software features',
    },
  ],
  [ShopifyStore.MX]: [
    {
      id: 'afib-detection',
      name: 'AFib Detection',
      description: 'Advanced atrial fibrillation detection',
    },
    {
      id: 'cycle-ovulation-pro',
      name: 'Cycle & Ovulation Pro (for women)',
      description: "Comprehensive women's health tracking",
    },
    {
      id: 'tesla-sync',
      name: 'UltraSync for Tesla',
      description: 'Seamless integration with Tesla vehicles',
    },
    {
      id: 'future-powerplugs',
      name: 'All future PowerPlugs',
      description: 'Access to all upcoming software features',
    },
  ],
  [ShopifyStore.ZA]: [
    {
      id: 'afib-detection',
      name: 'AFib Detection',
      description: 'Advanced atrial fibrillation detection',
    },
    {
      id: 'cycle-ovulation-pro',
      name: 'Cycle & Ovulation Pro (for women)',
      description: "Comprehensive women's health tracking",
    },
    {
      id: 'tesla-sync',
      name: 'UltraSync for Tesla',
      description: 'Seamless integration with Tesla vehicles',
    },
    {
      id: 'future-powerplugs',
      name: 'All future PowerPlugs',
      description: 'Access to all upcoming software features',
    },
  ],
  [ShopifyStore.JP]: [
    {
      id: 'afib-detection',
      name: 'AFib Detection',
      description: 'Advanced atrial fibrillation detection',
    },
    {
      id: 'cycle-ovulation-pro',
      name: 'Cycle & Ovulation Pro (for women)',
      description: "Comprehensive women's health tracking",
    },
    {
      id: 'tesla-sync',
      name: 'UltraSync for Tesla',
      description: 'Seamless integration with Tesla vehicles',
    },
    {
      id: 'future-powerplugs',
      name: 'All future PowerPlugs',
      description: 'Access to all upcoming software features',
    },
  ],
};

/**
 * Get lifetime software features for a specific Shopify store
 * @param store - The Shopify store region
 * @returns Array of lifetime software features for the store
 */
export const getLifetimeSoftwareFeatures = (
  store: ShopifyStore | null,
): LifetimeSoftwareFeature[] => {
  if (!store) {
    // Default to ROW features if store is not determined
    return lifetimeSoftwareFeaturesConfig[ShopifyStore.ROW];
  }

  return (
    lifetimeSoftwareFeaturesConfig[store] ||
    lifetimeSoftwareFeaturesConfig[ShopifyStore.ROW]
  );
};

export const getLifetimePowerPlugs = (
  store: ShopifyStore | null,
): LifetimePowerPlugsFeature[] => {
  if (!store) {
    // Default to ROW features if store is not determined
    return LifetimePowerPlugsModalConfig[ShopifyStore.ROW];
  }

  return (
    LifetimePowerPlugsModalConfig[store] ||
    LifetimePowerPlugsModalConfig[ShopifyStore.ROW]
  );
};

/**
 * Get a specific feature by ID for a store
 * @param store - The Shopify store region
 * @param featureId - The feature ID to retrieve
 * @returns The feature if found, undefined otherwise
 */
export const getLifetimeSoftwareFeature = (
  store: ShopifyStore | null,
  featureId: string,
): LifetimeSoftwareFeature | undefined => {
  const features = getLifetimeSoftwareFeatures(store);
  return features.find((feature) => feature.id === featureId);
};
